import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../../lib/shared/validators";

export const validatorInventoryCountItem = v.object({
  countId: v.id("inventory_counts"),
  productId: v.id("products"),
  name: v.string(),
  productCode: v.optional(v.string()),
  unit: v.string(),
  systemQuantity: v.number(),
  countedQuantity: v.number(),
  sortOrder: v.optional(v.number()),
  internalControl,
});

export const inventory_counts_items = defineTable(validatorInventoryCountItem)
  .index("by_count", ["countId"])
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_product", ["productId"]);
